import styled from '@emotion/styled';

export type StarSize = 'sm' | 'md' | 'lg';

export const sizeMap: Record<StarSize, string> = {
  sm: '20px',
  md: '28px',
  lg: '36px',
};

export const Container = styled.div<{ starSize: StarSize }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 4px;
    border-radius: 4px;
  }
`;

export const StarButton = styled.button<{ starSize: StarSize }>`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  transition: transform 0.15s ease;

  svg {
    width: ${({ starSize }) => sizeMap[starSize]};
    height: ${({ starSize }) => sizeMap[starSize]};
    transition: fill 0.1s ease;
  }

  &:hover {
    transform: scale(1.15);
  }

  &:focus {
    outline: none;
  }
`;
